import styled from "styled-components";

export const Container = styled.div`
  width: 95%;
  padding: 1rem;
  margin: 0 auto;
  border-radius: 5px;
  background-color: ${({theme}) => theme["container"]};

  ${({theme}) => theme.breakpoints.up("sm")} {
    width: 450px;
    margin: unset;
  }
`;
